export default __webpack_public_path__ + "static/media/E404.abb5b3d4.svg";